import styled from 'styled-components';

import { media } from '../../../styles/constants';
import { padding } from '../../../styles/padding';

const TabletsContainer = styled.div`
  display: flex;

  flex-wrap: wrap;
  position: relative;
  margin-top: 4rem;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
  }

  > div:first-child {
    width: 100%;
    min-width: 40rem;
    max-width: 92rem;
    order: 2;
    margin-left: -30%;
  }

  > div:last-child {
    width: 100%;
    min-width: 40rem;
    order: 1;
    margin-right: -30%;
  }

  @media (min-width: ${media.tabletLandscape}) {
    margin-top: 8.6rem;
    justify-content: initial;

    > div:first-child {
      width: 65%;
      padding: 15rem 0 0 ${padding.tabletLandscape.horizontal};
      margin-left: 0;
    }

    > div:last-child {
      position: absolute;
      width: 60%;
      margin-right: 0;
      left: auto;
      bottom: auto;
      right: -15rem;
      top: -15rem;
    }
  }

  @media (min-width: ${media.desktop}) {
    > div:first-child {
      width: 75%;
      padding-top: 0;
    }

    > div:last-child {
      right: -20rem;
      top: -30rem;
    }
  }
`;

export default TabletsContainer;
